"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseButtonContainer = exports.StyledAction = exports.FadeText = exports.StyledMessage = exports.MessageContainer = exports.ContentRow = exports.FadeWrapper = exports.Container = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const AlertBanner_types_1 = require("./AlertBanner.types");
const simpleFadeAnimation = (0, styled_components_1.keyframes) `
     0% {
       visibility: visible;
       opacity: 1;
     } 
     100% {
       visibility: visible;
        opacity: 0;
     }
`;
exports.Container = styled_components_1.default.div `
  background-color: ${({ type, theme }) => {
    if (type === AlertBanner_types_1.AlertBannerType.Information) {
        return theme.colors.colours.system['notification-strong'].value;
    }
    if (type === AlertBanner_types_1.AlertBannerType.Error) {
        return theme.colors.colours.system.fail.value;
    }
    if (type === AlertBanner_types_1.AlertBannerType.Warning) {
        return theme.colors.colours.system['alert-strong'].value;
    }
    if (type === AlertBanner_types_1.AlertBannerType.Success) {
        return theme.colors.colours.system.success.value;
    }
    return theme.colors.colours.system['notification-strong'].value;
}};
`;
exports.FadeWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  opacity: 1;
  height: ${({ theme }) => theme.sizes.xl.value};
  transition: height 0.2s ease-in-out;
  & > div {
    width: 100%;
  }
  ${({ show }) => show &&
    (0, styled_components_1.css) `
      transition: height 0.35s ease-in-out;
      animation: ${simpleFadeAnimation} 0.3s ease-in-out;
      visibility: hidden;
      height: 0px;
    `}
`;
exports.ContentRow = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  height: 100%;
  min-height: ${({ theme }) => theme.sizes.xl.value};
  padding-left: ${({ theme }) => theme.sizes['2xs'].value};
`;
exports.MessageContainer = styled_components_1.default.div `
  padding-top: ${({ theme }) => theme.sizes['2xs'].value};
  padding-bottom: ${({ theme, applyMarginBottom }) => applyMarginBottom && theme.sizes['2xs'].value};
  display: flex;
  align-items: center;
  @media (min-width: ${({ breakpoint }) => breakpoint}) {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: fit-content;
    max-width: calc(100% - 300px);
    padding: ${({ theme }) => theme.sizes['2xs'].value} 0px;
  }
  svg {
    min-height: ${({ theme }) => theme.sizes.m.value};
    min-width: ${({ theme }) => theme.sizes.m.value};
    padding-right: ${({ theme }) => theme.sizes.xs.value};
  }
  div:not(:last-child) {
    padding-right: ${({ theme }) => theme.sizes.s.value};
  }
`;
exports.StyledMessage = styled_components_1.default.div `
  overflow: hidden;
  display: flex;
  align-items: center;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  transition: all 0.2s linear, color 0;
  color: ${({ color, theme }) => theme.colors['text-colours'][color].value};
  ${({ hideText, isMobile }) => {
    if (hideText && isMobile) {
        return (0, styled_components_1.css) `
        -webkit-line-clamp: 1;
        line-clamp: 1;
      `;
    }
    if (!hideText && isMobile) {
        return (0, styled_components_1.css) `
        -webkit-line-clamp: 3;
        line-clamp: 3;
      `;
    }
    return (0, styled_components_1.css) `
      -webkit-line-clamp: 2;
      line-clamp: 2;
    `;
}}
`;
exports.FadeText = styled_components_1.default.div `
  height: 18px;
  transition: all 0.2s linear;
  ${({ fire, currentElementHeight }) => {
    if (!fire && currentElementHeight && currentElementHeight > 18) {
        return (0, styled_components_1.css) `
        height: ${currentElementHeight}px;
      `;
    }
    return null;
}}
`;
exports.StyledAction = styled_components_1.default.div `
  white-space: nowrap;
  text-overflow: ellipsis;
  box-sizing: border-box;
  margin-left: auto;
  button {
    text-decoration: underline;
  }
  @media (max-width: ${({ breakpoint }) => breakpoint}) {
    margin-right: ${({ theme }) => theme.sizes.s.value};
  }
`;
exports.CloseButtonContainer = styled_components_1.default.div `
  cursor: Pointer;
  margin-left: auto;
  margin-right: ${({ theme }) => theme.sizes['2xs'].value};
  display: flex;
  align-items: center;
  ${({ triggerFadeAnimation }) => triggerFadeAnimation &&
    (0, styled_components_1.css) `
      animation: ${simpleFadeAnimation} 0.2s ease-in-out;
      transition-delay: visibility 0.2s;
      visibility: hidden;
    `}
`;
//# sourceMappingURL=AlertBanner.styled.js.map